export default {
  name: 'Regen Score',
  domain: 'regenscore',
  id: '600f3077e51f5d000136b258',
  slug: 'regen1',
  path: '/regen1/',
  logo: '/partners/regenscore/img/logo.png',
  themes: {
    light: {
      primary: '#9cc000',
      secondary: '#9cc000',
      accent: '#1c75bc',
      error: '#f44336',
      warning: '#ffc107',
      info: '#9cc000',
      success: '#8bc34a',
      appbar: '#FFFFFF',
    },
  },
};
